module IamButton
open Elmish
open ListView
open Fable.React
open Fulma
open Fable.Core.JS
open Fable.React.Props
open Dotyk.Portal.Model

type State =
| Error of string
| NotConnected of ListView.State<SubscriptionInfo>
| Connecting of SubscriptionInfo
| Connected 

type Msg =
| Connect of SubscriptionInfo
| Connected of string
| ConnectError of exn
| ListMsg of ListView.Msg<unit, SubscriptionInfo>

let private progress =
    div
        [ Class "v-align" ]
        [ Fulma.Progress.progress [ Progress.Size (Fulma.Size.IsSmall); ] [] ]

let private connectView model dispatch =
    match model with
    | { items = [] } -> nothing
    | _ ->
        div []
            [ ListView.dropDownList
                model
                (str "Select subscription")
                (ListView.Msg.Selected >> ListMsg >> dispatch)
                (fun i -> i.name |> Option.defaultValue i.id |> str)

              match model with
              | ({ selected = Some sub}) ->
                    Button.button
                        [ Button.OnClick (fun _ -> sub |> Connect |> dispatch)]
                        [ str "Connect" ]
              | _ -> nothing
            ]

let private notConnectedView openIam model dispatch =
    [ Button.button [ Button.OnClick (fun _ -> openIam() )] [ str "Open legacy access editor" ]
      match model with
      | ListView.State.List list -> nothing//connectView list dispatch
      | ListView.State.Loading -> progress
      | ListView.State.Error e -> nothing
    ]
    |> List.map List.singleton
    |> List.map (Column.column [ Column.Width(Screen.All, Column.IsNarrow )])
    |> Columns.columns
       [Columns.IsMobile
        Columns.IsMultiline
        Columns.IsVCentered]

let private mapSubResult modelMap cmdMap (model,cmd) =
    (modelMap model, Cmd.map cmdMap cmd)

let init (loadSubs: (unit -> Promise<SubscriptionInfo list>)) (iam: IamInfo option) =
    match iam with
    | Some ({ id = Some id })-> State.Connected, Cmd.Empty
    | Some { id = None } -> ListView.init (loadSubs) () |> mapSubResult State.NotConnected ListMsg
    | None -> State.Connected, Cmd.Empty

let update
    (connect: SubscriptionInfo -> Promise<string>)
    msg model =
    match msg with
    | ListMsg msg ->
        match model with
        | NotConnected nc -> ListView.update (fun _ -> true) false msg nc |> mapSubResult State.NotConnected ListMsg
        | _ -> model, Cmd.Empty
    | Connect sub -> Connecting sub, Cmd.OfPromise.either connect sub Msg.Connected ConnectError
    | Connected iamId ->
        match model with
        | Connecting _ -> State.Connected, Cmd.Empty
        | _ -> model, Cmd.Empty
    | ConnectError error ->
        match model with
        | Connecting _ -> State.Error (error.ToString()), Cmd.Empty
        | _ -> model, Cmd.Empty

let view
    (model: State)
    (dispatch: Dispatch<Msg>)
    (openIam: Dispatch<unit>) =
    match model with
    | Connecting _ -> progress
    | Error e -> div [] [ str "Error "; str  e]
    | NotConnected nc -> notConnectedView openIam nc dispatch
    | State.Connected -> Button.button [ Button.OnClick (fun _ -> openIam() )] [ str "Open access editor" ]


let editorView iamUrl app langs =
    match app.iam with
    | Some { id = Some iamId } ->
        Some "iam-container",
        AppHost.iamWindow iamUrl iamId langs
    | _ ->
        None,
        AccessEditor.accessEditor app.url
        
    
    
    
